var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseIconTooltip',{attrs:{"color":_vm.iconData.color,"iconType":_vm.iconData.type,"message":_vm.iconData.message}})
}
var staticRenderFns = []

export { render, staticRenderFns }